import { combineReducers } from '@reduxjs/toolkit'
import { ClosedWonQueueSubmissionsState } from './widgets/closedWonQueueSubmissions/typings'
import { GainMoreCustomersState } from './widgets/gainMoreCustomers/typings'
import { ManageAgreementsState } from './widgets/manageAgreements/typings'
import { OverdueNextActionDatesState } from './widgets/overdueNextActionDates/typings'
import { UpcomingFollowUpsState } from './widgets/upcomingFollowUps/typings'

import {
  reducer as closedWonQueueSubmissionsReducer,
  initialState as initialStateClosedWonQueueSubmissions,
} from './widgets/closedWonQueueSubmissions/slice'

import {
  reducer as manageAgreementsReducer,
  initialState as initialStateManageAgreements,
} from './widgets/manageAgreements/manageAgreements'

import {
  reducer as gainMoreCustomersReducer,
  initialState as initialStateGainMoreCustomers,
} from './widgets/gainMoreCustomers/slice'

import {
  reducer as overdueNextActionDatesReducer,
  initialState as initialStateOverdueNextActionDates,
} from './widgets/overdueNextActionDates/slice'

import {
  reducer as upcomingFollowUpsReducer,
  initialState as initialStateUpcomingFollowUps,
} from './widgets/upcomingFollowUps/slice'

export const initialState: DashboardState = {
  closedWonQueueSubmissions: initialStateClosedWonQueueSubmissions,
  gainMoreCustomers: initialStateGainMoreCustomers,
  manageAgreements: initialStateManageAgreements,
  overdueNextActionDates: initialStateOverdueNextActionDates,
  upcomingFollowUps: initialStateUpcomingFollowUps,
}

export interface DashboardState {
  closedWonQueueSubmissions: ClosedWonQueueSubmissionsState
  gainMoreCustomers: GainMoreCustomersState
  manageAgreements: ManageAgreementsState
  overdueNextActionDates: OverdueNextActionDatesState
  upcomingFollowUps: UpcomingFollowUpsState
}

const dashboardSlice = combineReducers({
  closedWonQueueSubmissions: closedWonQueueSubmissionsReducer,
  gainMoreCustomers: gainMoreCustomersReducer,
  manageAgreements: manageAgreementsReducer,
  overdueNextActionDates: overdueNextActionDatesReducer,
  upcomingFollowUps: upcomingFollowUpsReducer,
})

export default dashboardSlice
